import { callApi } from "./service";

const dashboardApi = process.env.REACT_APP_DASHBOARD_API;

export function* getHTMLSitemap() {
  const payload = {
    method: "GET",
    url: `${dashboardApi}/seo/autoketing-sitemap`,
    params: {},
  };
  return yield callApi(payload);
}

export function* editHTMLSitemap(data) {
  const payload = {
    method: "PATCH",
    url: `${dashboardApi}/seo/autoketing-sitemap`,
    params: data.payload,
  };
  return yield callApi(payload);
}
